import styled from '@emotion/styled';
import Card from '__components/Card/Card';

export const Screen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: calc(100vw - var(--app-inset-right, 0px));
  margin: 20vh auto;
`;

export const StyledCard = styled(Card)`
  max-width: 450px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 35px 20px 35px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

export const InputFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 10px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`;
